export default __webpack_public_path__ + "static/media/mobitelLogo.1f4fdbdc.png";